import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    primary: {
      light: '#93cb68',
      main: '#78BE43',
      dark: '#54852e',
      contrastText: '#fff',
    },
    secondary: {
      light: '#93cb68',
      main: '#e6e6e6',
      dark: '#d3d3d3',
      contrastText: '#636363',
    },
  },
});

export default theme;
